import { INiche } from "@/common/services/types";
import { Columnizer } from "components/blocks/Columnizer";
import { NicheBlockPlaceholder } from "components/UI/Skeleton/Skeleton";
import { clsx } from "clsx";
import { useFollowingNiche } from "@/common/hooks/useFollowingNiche";

import "./index.scss";
import { NicheCatalogItem } from "../NicheCatalogItem/NicheCatalogItem";
import InfiniteScroll from "react-infinite-scroll-component";
import { deviceTypeEnum } from "@/common/utils/device";
import { ReactElement } from "react";
import { useDeviceType } from "@/common/hooks";

/* eslint-disable no-magic-numbers */

const COLUMN_SIZES = [500];

/* eslint-enable no-magic-numbers */

export const NicheCatalog = (props: {
  niches: INiche[];
  myNiche?: boolean;
  isLoading: boolean;
  withPreview?: boolean;
  hasMore: boolean;
  fetchMore: () => void;
}): ReactElement => {
  const { onFollow, isFollowing } = useFollowingNiche();
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;

  const classes = clsx([
    "niches",
    "nicheCatalog"
  ]);

  const renderNiches = () => {
    if (!props.niches.length && props.isLoading) {
      // eslint-disable-next-line no-magic-numbers
      return new Array(!props.withPreview ? 50 : 8).fill("").map((___, index) => <NicheBlockPlaceholder key={index} />);
    }

    if (!props.niches.length && !props.isLoading) {
      return <p>No niches to show on this page.</p>;
    }

    return props.niches.map((niche: INiche) => (
      <NicheCatalogItem
        key={niche.id}
        niche={niche}
        following={isFollowing(niche.id)}
        onFollow={onFollow}
        isLink={props.myNiche}
        withPreview={props.withPreview}
      />
    ));
  };

  return (
    <div className={classes}>
      <InfiniteScroll
        dataLength={props.niches.length}
        hasMore={props.hasMore}
        next={props.fetchMore}
        loader={<></>}
        scrollableTarget={!isDesktop ? "scrollableDiv" : undefined}
      >
        <Columnizer sizes={COLUMN_SIZES}>
          {renderNiches()}
        </Columnizer>
      </InfiniteScroll>
    </div>
  );
};
